import MapChart from './MapChart';
import ReactSimpleMap from './ReactSimpleMap';
import StaticGmap from './StaticGmap';

export { ReactSimpleMap, StaticGmap };

export default MapChart;
